import { memo } from 'react';
import styled from 'styled-components';

import type { CommonAlertModalProps } from '@wecasa/common/src/types/components';
import { toRem } from '@wecasa/common/src/utils/styles';

import { useIsMobile } from '../../styles/media-queries';
import Button, { type ButtonProps } from '../button/button';
import BaseModal from './base-modal';

export const ModalContent = styled.div`
  padding: 0 20px 20px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 ${toRem(15)} ${toRem(20)};
`;

const StyledButton = styled(Button)`
  margin: 0 ${toRem(5)};
`;

type AlertModalButtonProps = Pick<
  ButtonProps,
  'variant' | 'isDisabled' | 'isLoading' | 'children' | 'hasFullWidth' | 'type' | 'onPress'
>;

type AlertModalProps = CommonAlertModalProps<AlertModalButtonProps>;

const Modal = ({ children, isOpen, title, onClose, primaryButton, secondaryButton }: AlertModalProps) => {
  const isMobile = useIsMobile();
  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title={title}>
      {children}
      {(primaryButton || secondaryButton) && (
        <ModalFooter>
          {secondaryButton && (
            <StyledButton size='lg' variant='secondary' hasFullWidth={!!primaryButton && isMobile} {...secondaryButton}>
              {secondaryButton.children}
            </StyledButton>
          )}
          {primaryButton && (
            <StyledButton size='lg' hasFullWidth={!!secondaryButton && isMobile} {...primaryButton}>
              {primaryButton.children}
            </StyledButton>
          )}
        </ModalFooter>
      )}
    </BaseModal>
  );
};

export default memo(Modal);
